import $ from 'jquery';
import WheelIndicator from 'wheel-indicator';

/* Clients Section Carousel */
export const carouselClients = () => {

    const clientsCarouselmages = document.querySelectorAll('.carousel--clients .clients-section__item img');
    const clientsCarouselBackground = document.querySelector('.clients-section__background');

    $('.carousel--clients').on('init', function() {
        const dots = document.querySelectorAll('.carousel--clients .slick-dots li');

        $.each(clientsCarouselmages, function(imageIndex, image) {
            $.each(dots, function(dotIndex, dot) {
                if (imageIndex == dotIndex) {
                    const imageSrc = $(image).attr('src');
                    $(dot).css('background-image', 'url(' + imageSrc + ')');
                }
            });
        });

        $(clientsCarouselBackground).addClass('clients-section__background--animation');
    });

	$('.carousel--clients').slick({
        infinite: true,
		autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        pauseOnHover: true,
        fade: true,
        responsive: [
            {
                breakpoint: 1240,
                settings: {
                    infinite: false,
                    autoplay: false,
                    dots: false,
                    arrows: true,
                    fade: false,
                    prevArrow: '<div class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.73698 3.43795L11.8583 5.55926L6.50648 10.9111L22.9145 10.9111L22.9145 13.9111L6.97948 13.9111L11.8581 18.7897L9.7368 20.911L3.12166 14.2959L3.12158 14.296L1.00026 12.1747L1.00034 12.1746L1.00008 12.1743L3.1214 10.053L3.12166 10.0533L9.73698 3.43795Z" fill="white"/></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.263 20.5621L12.1417 18.4407L17.4935 13.0889L1.08549 13.0889L1.08549 10.0889L17.0205 10.0889L12.1419 5.21028L14.2632 3.08896L20.8783 9.7041L20.8784 9.70402L22.9997 11.8253L22.9997 11.8254L22.9999 11.8257L20.8786 13.947L20.8783 13.9467L14.263 20.5621Z" fill="white"/></svg></div>',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    infinite: false,
                    autoplay: false,
                    dots: false,
                    arrows: true,
                    fade: false,
                    prevArrow: '<div class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.73698 3.43795L11.8583 5.55926L6.50648 10.9111L22.9145 10.9111L22.9145 13.9111L6.97948 13.9111L11.8581 18.7897L9.7368 20.911L3.12166 14.2959L3.12158 14.296L1.00026 12.1747L1.00034 12.1746L1.00008 12.1743L3.1214 10.053L3.12166 10.0533L9.73698 3.43795Z" fill="white"/></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.263 20.5621L12.1417 18.4407L17.4935 13.0889L1.08549 13.0889L1.08549 10.0889L17.0205 10.0889L12.1419 5.21028L14.2632 3.08896L20.8783 9.7041L20.8784 9.70402L22.9997 11.8253L22.9997 11.8254L22.9999 11.8257L20.8786 13.947L20.8783 13.9467L14.263 20.5621Z" fill="white"/></svg></div>',
                }
            },
        ],
	});

    $('.carousel--clients').on('beforeChange', function(event) {
        $(clientsCarouselBackground).removeClass('clients-section__background--animation');
        setTimeout(function () {
            $(clientsCarouselBackground).addClass('clients-section__background--animation');
        }, 10);
    });
};

/* Services Mobile Carousel */
export const carouselServices = () => {
    if ($(window).width() < 768) {
        const element = $('.services-section').find('.row').last();
        const content = $(element).html();
        $(element).empty();
        $(element).append('<div class="carousel carousel--services"></div>');
        $('.services-section .carousel').html(content);
    };

    $('.carousel--services').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.73698 3.43795L11.8583 5.55926L6.50648 10.9111L22.9145 10.9111L22.9145 13.9111L6.97948 13.9111L11.8581 18.7897L9.7368 20.911L3.12166 14.2959L3.12158 14.296L1.00026 12.1747L1.00034 12.1746L1.00008 12.1743L3.1214 10.053L3.12166 10.0533L9.73698 3.43795Z" fill="white"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.263 20.5621L12.1417 18.4407L17.4935 13.0889L1.08549 13.0889L1.08549 10.0889L17.0205 10.0889L12.1419 5.21028L14.2632 3.08896L20.8783 9.7041L20.8784 9.70402L22.9997 11.8253L22.9997 11.8254L22.9999 11.8257L20.8786 13.947L20.8783 13.9467L14.263 20.5621Z" fill="white"/></svg></div>',
        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick'
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },   
        ],
    });
};

/* Solutions Carousel */
export const carouselSolutions = () => {
    // https://github.com/kenwheeler/slick/issues/3668
    const sloutionsCarousel = $('.carousel--solutions')
    let wheel, scrolling;

    sloutionsCarousel.on('init', () => {
        wheel = new WheelIndicator({
            elem: sloutionsCarousel[0],
            callback: (event) => {
                if (!scrolling) {
                    sloutionsCarousel.slick(event.direction === 'up' ? 'slickPrev' : 'slickNext');
                }
            },
        });
    })
    .on('beforeChange', () => {
        scrolling = true;
    })
    .on('afterChange', () => {
        scrolling = false;
    })
    .slick({
        infinite: false,
		autoplay: false,
		autoplaySpeed: 6000,
        speed: 500,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        vertical: true,
        pauseOnHover: true,
        touchMove: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 768,
                settings: 'unslick',
            },
        ]
	});

    const animateElements = ['.links', '.solutions-section__info', '.btn'];
    const aosElements = ['.links', '.solutions-section__related', '.solutions-section__container', '.btn'];
    const contentElements = $('.solutions-section .solutions-section__content');

    // Center solutions slider content vertically based on heighest
    function centerSolutionsContent() {
        const parentHeight = $('.carousel--solutions').outerHeight();
        const breadcrumbsHeight = $('.solutions-section__header').outerHeight();
        let height = 0;

        $.each(contentElements, function(index, item) {
            $(item).css('padding-top', 0);
            if ($(item).outerHeight() > height) {
                height = $(item).outerHeight();
            }
        });

        $.each(contentElements, function(index, item) {
            $(item).css('padding-top', (parentHeight - height) / 2);
            $('.solutions-section .solutions-section__header').css('top', ((parentHeight - height) / 2 - breadcrumbsHeight - 30));
        });
    }

    if ($(window).width() >= 768) {
        // Remove AOS animations for slider
        $.each(aosElements, function(index, item) {
            $('.carousel--solutions ' + item).removeAttr('data-aos');
            $('.carousel--solutions ' + item).removeClass('aos-init aos-animate');
        });

        // Center content
        $(window).on('resize', function(){
            centerSolutionsContent();
        }).resize();
    }

    $.each(animateElements, function(index, item) {
        $('.carousel--solutions .slick-slide.slick-active ' + item).addClass('animate__animated animate__fadeInUp').css('opacity', 1);
    });
    
    $('.carousel--solutions').on('afterChange', function(event) {
        $.each(animateElements, function(index, item) {
            $('.carousel--solutions .slick-slide ' + item).removeClass('animate__animated animate__fadeInUp animate__fadeOutUp').css('opacity', 0);
            $('.carousel--solutions .slick-slide.slick-active ' + item).addClass('animate__animated animate__fadeInUp').css('opacity', 1);
        });
    });
};

/* Gallery Cursor */
const galleryCursor = (galleryCarousel) => {

    const galleryElement = $('.gallery');

    $(galleryElement).each(function(index, gallery) {
        const carousel = gallery.querySelector(galleryCarousel);
        const prevButton = gallery.querySelector('.slick-prev');
        const nextButton = gallery.querySelector('.slick-next');

        $(prevButton).hide();
        $(nextButton).hide();

        $(carousel).mousemove(function(e) {
            const carouselRect = carousel.getBoundingClientRect();

            // Checking if cursor is over carousel
            if (e.clientY > carouselRect.y && e.clientY < (carouselRect.height + carouselRect.y - 100)) {

                // Checking if cursor is on prev side
                if (e.clientX > carouselRect.x && e.clientX < (carouselRect.width / 2 + carouselRect.x)) {
                    $(nextButton).hide();
                    $(prevButton).show();
                    $(prevButton).css({'top': e.clientY - carouselRect.y + 'px', 'left': e.clientX - carouselRect.x + 'px'})
                }

                // Checking if cursor is on next side
                if (e.clientX > carouselRect.x && e.clientX > (carouselRect.width / 2 + carouselRect.x) && e.clientX < (carouselRect.width + carouselRect.x)) {
                    $(prevButton).hide();
                    $(nextButton).show();
                    $(nextButton).css({'top': e.clientY - carouselRect.y + 'px', 'left': e.clientX - carouselRect.x + 'px'})
                }
            } else {
                $(prevButton).hide();
                $(nextButton).hide();
            };
        });

        $(carousel).mouseleave(function() {
            $(prevButton).hide();
            $(nextButton).hide();
        });
    });
}

/* Gallery Carousel */
export const carouselGallery = () => {
    $('.carousel--gallery').slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        autoplaySpeed: 4000,
        centerMode: true,
        adaptiveHeight: true,
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-arrow-prev"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" transform="rotate(-180 82 72)" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" transform="rotate(-180 82 72)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M92.9145 73.9112L92.9145 70.9112L76.5065 70.9112L81.8583 65.5593L79.737 63.438L73.1217 70.0533L73.1214 70.053L71.0001 72.1744L71.0004 72.1746L71.0003 72.1747L73.1216 74.296L73.1217 74.2959L79.7368 80.9111L81.8582 78.7898L76.9796 73.9112L92.9145 73.9112Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
        nextArrow: '<div class="slick-arrow-next"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M71.0855 70.0888L71.0855 73.0888L87.4935 73.0888L82.1417 78.4407L84.263 80.562L90.8783 73.9467L90.8786 73.9469L92.9999 71.8256L92.9996 71.8254L92.9997 71.8253L90.8784 69.704L90.8783 69.7041L84.2632 63.0889L82.1418 65.2102L87.0204 70.0888L71.0855 70.0888Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    prevArrow: '<div class="slick-prev"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" transform="rotate(-180 82 72)" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" transform="rotate(-180 82 72)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M92.9145 73.9112L92.9145 70.9112L76.5065 70.9112L81.8583 65.5593L79.737 63.438L73.1217 70.0533L73.1214 70.053L71.0001 72.1744L71.0004 72.1746L71.0003 72.1747L73.1216 74.296L73.1217 74.2959L79.7368 80.9111L81.8582 78.7898L76.9796 73.9112L92.9145 73.9112Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M71.0855 70.0888L71.0855 73.0888L87.4935 73.0888L82.1417 78.4407L84.263 80.562L90.8783 73.9467L90.8786 73.9469L92.9999 71.8256L92.9996 71.8254L92.9997 71.8253L90.8784 69.704L90.8783 69.7041L84.2632 63.0889L82.1418 65.2102L87.0204 70.0888L71.0855 70.0888Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                    prevArrow: '<div class="slick-prev"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" transform="rotate(-180 82 72)" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" transform="rotate(-180 82 72)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M92.9145 73.9112L92.9145 70.9112L76.5065 70.9112L81.8583 65.5593L79.737 63.438L73.1217 70.0533L73.1214 70.053L71.0001 72.1744L71.0004 72.1746L71.0003 72.1747L73.1216 74.296L73.1217 74.2959L79.7368 80.9111L81.8582 78.7898L76.9796 73.9112L92.9145 73.9112Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M71.0855 70.0888L71.0855 73.0888L87.4935 73.0888L82.1417 78.4407L84.263 80.562L90.8783 73.9467L90.8786 73.9469L92.9999 71.8256L92.9996 71.8254L92.9997 71.8253L90.8784 69.704L90.8783 69.7041L84.2632 63.0889L82.1418 65.2102L87.0204 70.0888L71.0855 70.0888Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                },
            },
        ]
    });

    if ($(window).width() > 767) {
        galleryCursor('.carousel--gallery');
    }
};

/* Gallery Single Carousel */
export const carouselGallerySingle = () => {
    $('.carousel--gallery-single').slick({
        infinite: false,
        autoplay: true,
        slidesToShow: 1,
        autoplaySpeed: 4000,
        speed: 500,
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-arrow-prev"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" transform="rotate(-180 82 72)" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" transform="rotate(-180 82 72)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M92.9145 73.9112L92.9145 70.9112L76.5065 70.9112L81.8583 65.5593L79.737 63.438L73.1217 70.0533L73.1214 70.053L71.0001 72.1744L71.0004 72.1746L71.0003 72.1747L73.1216 74.296L73.1217 74.2959L79.7368 80.9111L81.8582 78.7898L76.9796 73.9112L92.9145 73.9112Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
        nextArrow: '<div class="slick-arrow-next"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M71.0855 70.0888L71.0855 73.0888L87.4935 73.0888L82.1417 78.4407L84.263 80.562L90.8783 73.9467L90.8786 73.9469L92.9999 71.8256L92.9996 71.8254L92.9997 71.8253L90.8784 69.704L90.8783 69.7041L84.2632 63.0889L82.1418 65.2102L87.0204 70.0888L71.0855 70.0888Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    dots: true,
                    prevArrow: '<div class="slick-prev"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" transform="rotate(-180 82 72)" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" transform="rotate(-180 82 72)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M92.9145 73.9112L92.9145 70.9112L76.5065 70.9112L81.8583 65.5593L79.737 63.438L73.1217 70.0533L73.1214 70.053L71.0001 72.1744L71.0004 72.1746L71.0003 72.1747L73.1216 74.296L73.1217 74.2959L79.7368 80.9111L81.8582 78.7898L76.9796 73.9112L92.9145 73.9112Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="82" cy="72" r="52" fill="white"/></g><circle opacity="0.5" cx="82" cy="72" r="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M71.0855 70.0888L71.0855 73.0888L87.4935 73.0888L82.1417 78.4407L84.263 80.562L90.8783 73.9467L90.8786 73.9469L92.9999 71.8256L92.9996 71.8254L92.9997 71.8253L90.8784 69.704L90.8783 69.7041L84.2632 63.0889L82.1418 65.2102L87.0204 70.0888L71.0855 70.0888Z" fill="#FEA800"/><defs><filter id="filter0_d" x="0" y="0" width="164" height="164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="10"/><feGaussianBlur stdDeviation="15"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg></div>',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    prevArrow: '<div class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.73698 3.43795L11.8583 5.55926L6.50648 10.9111L22.9145 10.9111L22.9145 13.9111L6.97948 13.9111L11.8581 18.7897L9.7368 20.911L3.12166 14.2959L3.12158 14.296L1.00026 12.1747L1.00034 12.1746L1.00008 12.1743L3.1214 10.053L3.12166 10.0533L9.73698 3.43795Z" fill="white"/></svg></div>',
                    nextArrow: '<div class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.263 20.5621L12.1417 18.4407L17.4935 13.0889L1.08549 13.0889L1.08549 10.0889L17.0205 10.0889L12.1419 5.21028L14.2632 3.08896L20.8783 9.7041L20.8784 9.70402L22.9997 11.8253L22.9997 11.8254L22.9999 11.8257L20.8786 13.947L20.8783 13.9467L14.263 20.5621Z" fill="white"/></svg></div>',
                },
            },
        ]
    });

    if ($(window).width() > 767) {
        galleryCursor('.carousel--gallery-single');
    }
};

/* Expertise Carousel */
export const carouselExpertise = () => {
    const toggleExpertiseCarouselClass = (slick) => {
        if (slick.slideCount <= slick.options.slidesToShow) {
            $(slick.$slider).addClass('no-arrows');
        } else {
            $(slick.$slider).removeClass('no-arrows');
        }
    };

    $('.carousel--expertise').on('init reInit breakpoint', function (event, slick) {
        toggleExpertiseCarouselClass(slick);
    });

    $('.carousel--expertise').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 4,
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.73698 3.43795L11.8583 5.55926L6.50648 10.9111L22.9145 10.9111L22.9145 13.9111L6.97948 13.9111L11.8581 18.7897L9.7368 20.911L3.12166 14.2959L3.12158 14.296L1.00026 12.1747L1.00034 12.1746L1.00008 12.1743L3.1214 10.053L3.12166 10.0533L9.73698 3.43795Z" fill="white"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.263 20.5621L12.1417 18.4407L17.4935 13.0889L1.08549 13.0889L1.08549 10.0889L17.0205 10.0889L12.1419 5.21028L14.2632 3.08896L20.8783 9.7041L20.8784 9.70402L22.9997 11.8253L22.9997 11.8254L22.9999 11.8257L20.8786 13.947L20.8783 13.9467L14.263 20.5621Z" fill="white"/></svg></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },   
        ],
    });
};
